<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="table-responsive signal-table">
        <table class="table table-hover">
          <thead>
            <tr>
              <th scope="col">Id</th>
              <th scope="col">Nombre Completo</th>
              <th scope="col">Usuario</th>
              <th scope="col">Activo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="paginatedItems.length === 0">
              <td colspan="4">
                <EmptyState
                  title="No hay solicitantes registrados."
                  :size="450"
                  fontSize="fs-5"
                />
              </td>
            </tr>
            <tr v-else v-for="user in paginatedItems" :key="user.id">
              <th scope="row">{{ user.id }}</th>
              <td>
                {{ user.name }} {{ user.first_last_name }}
                {{ user.second_last_name }}
              </td>
              <td>{{ user.username }}</td>
              <td>
                <div class="media-body icon-state switch-outline">
                  <label class="switch">
                    <input
                      type="checkbox"
                      @change="changeStatusUser(user.id)"
                      :checked="user.has_access"
                    />
                    <span class="switch-state bg-primary"></span>
                  </label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <pagination
          class="card"
          style="padding-bottom: 10px"
          :totalItems="users.length"
          :itemsPerPage="itemsPerPage"
          @page-change="handlePageChange"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import Pagination from "@/pages/components/Pagination.vue";
import { ref, computed } from "vue";

const props = defineProps({ users: Array });
const emit = defineEmits(["change-status"]);

const currentPage = ref(1);
const itemsPerPage = ref(10);

const paginatedItems = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value;
  return props.users.slice(start, start + itemsPerPage.value);
});

function handlePageChange(page) {
  currentPage.value = page;
}

function changeStatusUser(id) {
  emit("change-status", id);
}
</script>
